<template>
    <button v-show="!focusedPlayer" class="overlay-button" id="focus-video-btn" @click="focusPlayer" v-html="SVG.MAXIMIZE_SVG"></button>
    <button v-show="focusedPlayer" class="overlay-button" id="unfocus-video-btn" @click="unfocusPlayer" v-html="SVG.MINIMIZE_SVG"></button>
        <button v-show="!focusedPlayer" class="overlay-button" id="switch-btn-video" @click="changeVideoSlide"  v-html="SVG.SWITCH"></button>


  <div class="full-screen-section"></div>
</template>

<script >
import { defineComponent } from "vue";
import { SVG } from "@/components/utils/const";
import { updateOverlayButtonsPosition ,updateBigPlayButton ,changeVideoSlide} from "../../utils/richmedia.js";

export default defineComponent({
  name: "interacitive-buttons",
  components: {},
  props: {
    player: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
    SVG:SVG,
    changeVideoSlide:changeVideoSlide,
      focusedPlayer: false,
      focusedSlides: false,
      videoWrapperStyle: {},
      slidesBigWrapper: null,
      videoWrapper: null,
      slidesWrapper: null,
      playerWrapper: null,
      isGallerySlides: true,

    };
  },

  methods: {
  

    focusPlayer() {
        const videoElementWrapper = document.getElementById(
        "vjs_video_3"
      );
  var video = document.querySelector('.vjs-tech');
    videoElementWrapper.classList.add('vjs-popout');
    video.classList.add('focused');
          this.focusedPlayer=true
  updateOverlayButtonsPosition();
  updateBigPlayButton();
    },
    unfocusPlayer() {
        const videoElementWrapper = document.getElementById(
        "vjs_video_3"
      );

  var video = document.querySelector('.vjs-tech');
    
    videoElementWrapper.classList.remove('vjs-popout');
    video.classList.remove('focused');
    this.focusedPlayer=false


  
  updateOverlayButtonsPosition();
  updateBigPlayButton();
    },

  },
});
</script>

<style>
/* .overlay-buttons-content-video,
.overlay-buttons-content-slides{
  position: absolute;
} */
.video-js.vjs-slides.vjs-playing:not(.vjs-user-active) #dark-overlay-buttons {
      bottom: calc(0.5em + 25%);

}
.video-js.vjs-has-started #dark-overlay-buttons {
    position: absolute;
    right: 51%;
    bottom: calc(3.5em + 25%);
    z-index: 2;
    display: flex;
    margin: .5em;
    transition: .3s ease;


}

.vjs-has-started .overlay-buttons-content-slides {
position: absolute;
    bottom: 0;
    right: 0;
    margin: .5em;
    display: flex;
}

.overlay-button {
cursor: pointer;
  background: var(--vm-color-one-08)  !important;
    padding: .5em;
    margin-left: .2em;
    border-radius: .25rem;
    font-size: 1.5em !important;
}

.overlay-button svg {
  width: 1.25em;
  height: 1.25em;
}

.overlay-button svg path {
  fill: blanchedalmond;
}

.full-screen-section {
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--vm-color-one);
  z-index: 100;
}

.full-screen-section #rm-slides {
  height: 100%;
  position: absolute;
  left: 25%;
  right: 25%;
  bottom: 0;
}
.focused {
    position: absolute;
    left: 0;
    right: 0;
    height: 100% !important;
    width: 100% !important;
    z-index: 3;
    background-color: rgba(0, 0, 0, .8);
    padding-bottom: 0;
}
.full-screen-section .divider-wrapper {
  display: none;
}
 .video-js.vjs-slides.vjs-popout.vjs-has-started .vjs-tech.focused~#dark-overlay-buttons {
  top: 0 !important;
    right: 0 !important;
    bottom: auto !important;
    z-index: 4 !important;

    }
 .video-js.vjs-slides.vjs-popout.vjs-has-started #rm-slides.focused #dark-overlay-buttons-slides {
        top: 0 !important;
        right: 0 !important;
        bottom: auto !important;
        z-index: 4 !important;
    }
</style>
